import styles from "../../../styles/shared/create-bot/CreateBotSettings.module.css";
import React from "react";
import { InputNumber } from "antd";
import { TbReportSearch } from "react-icons/tb";
import { FaMinus, FaPlus } from "react-icons/fa6";

function CoinNumbersSettings({ coinNum, changeConfig }) {
  const controllerHandler = (action) => () => {
    const currentValue = Number(coinNum);

    if (action === "minus") {
      if (currentValue === 0 || currentValue === 1) return;
      changeConfig("number_of_coins", `${currentValue - 1}`);
    } else {
      if (currentValue === 30) return;
      changeConfig("number_of_coins", `${currentValue + 1}`);
    }
  };

  return (
    <>
      <div className={styles.stepTitle}>
        <h6>
          <TbReportSearch color="#0c4cfc" size={18} /> Number of Coins to
          Include
        </h6>
      </div>

      <div className={styles.inputNumberContainer}>
        <span
          className={`${styles.inputController} ${Number(coinNum) === 1 ? styles.disabledController : ""}`}
          onClick={controllerHandler("minus")}
        >
          <FaMinus />
        </span>
        <InputNumber
          style={{ borderRadius: ".3rem" }}
          min={1}
          max={30}
          value={coinNum}
          onChange={(value) => changeConfig("number_of_coins", `${value}`)}
          controls={false}
        />
        <span
          className={`${styles.inputController} ${Number(coinNum) === 30 ? styles.disabledController : ""}`}
          onClick={controllerHandler("plus")}
        >
          <FaPlus />
        </span>
      </div>

      <p style={{ marginBottom: 0, color: "#888888" }}>
        <strong style={{ marginRight: ".3rem"}}>NOTE:</strong>
        For optimal results, we suggest that you choose between 3 and 5 coins.
      </p>
    </>
  );
}

export default CoinNumbersSettings;
